var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ObfuscationLink',{staticClass:"labeled-link-standard",style:({ 'background-image': `url(${_vm.image.url})` }),attrs:{"link":_vm.link,"is-active-obfuscated-link":_vm.obfuscatedActived}})
}
var staticRenderFns = []

export { render, staticRenderFns }